import { defineComponent as l, ref as f, provide as u, watch as m, createElementBlock as c, openBlock as d, mergeProps as w, unref as n, renderSlot as k } from "vue";
import B from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/OverflowMenu/overflow-menu.js";
import { useWindowSize as v } from "@vueuse/core";
import { globalBreakpoints as b } from "../Toolbar/common.js";
import { useOUIAProps as S } from "../../helpers/ouia.js";
const h = Symbol("OverflowMenuIsBelowBreakpointKey"), _ = /* @__PURE__ */ l({
  name: "PfOverflowMenu",
  __name: "OverflowMenu",
  props: {
    breakpoint: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(i) {
    const e = i, a = S({ id: e.ouiaId, safe: e.ouiaSafe }), r = f(!1);
    u(h, r);
    const { width: s } = v();
    return m(s, (o) => {
      const t = b[e.breakpoint], p = Number(t.toString().replace("px", ""));
      r.value = o < p;
    }, { immediate: !0 }), (o, t) => (d(), c("div", w(n(a), {
      class: n(B).overflowMenu
    }), [
      k(o.$slots, "default")
    ], 16));
  }
});
export {
  h as OverflowMenuIsBelowBreakpointKey,
  _ as default
};
